import { createAction } from '@ngrx/store';

export const incrementNewCodeAttempt = createAction(
  '[OTP Component] Increment New Code Attempt'
);
